import useSWR from "swr";

import * as fetcher from "../fetcher";
import {
  type Appointment,
  type AppointmentQuestionsResponse,
  type QuestionObject,
} from "./types";

type BokaConfig = Record<string, Record<string, string[]>>;

interface BokaConfigResponse {
  enabled: BokaConfig;
}

interface AppointmentQuestionsData {
  questions: QuestionObject[];
  additionalQuestionsToken?: string;
}
export const useOpportunityAppointments = (opportunityId?: number) => {
  return useSWR<Appointment[]>(
    opportunityId ? `/${opportunityId}/appointments` : null,
    (url: string) => fetcher.opportunity.get(url),
    {
      revalidateOnFocus: true,
      refreshInterval: 60 * 1000,
    }
  );
};

export const useBokaStoresAndServices = () => {
  return useSWR<BokaConfig>("/appointment/config", async () => {
    const res = await fetcher.opportunity.get<BokaConfigResponse>(
      "/appointment/config"
    );
    return res.enabled;
  });
};

export const fetchAppointmentQuestions = async (
  appointmentId: number
): Promise<AppointmentQuestionsData> => {
  const res = await fetcher.opportunity.get<AppointmentQuestionsResponse>(
    `/appointments/${appointmentId}/questions`
  );
  return {
    additionalQuestionsToken: res.additionalQuestionsToken,
    questions: (res.questions ?? []).map((question) => ({
      question,
      answer: {
        questionId: question.id,
        answer: [],
      },
    })),
  };
};

export const useAppointmentQuestions = (
  appointmentId?: number,
  shouldFetch = true
) => {
  return useSWR<AppointmentQuestionsData>(
    shouldFetch && appointmentId
      ? `/appointments/${appointmentId}/questions`
      : null,
    () => fetchAppointmentQuestions(appointmentId!),
    {
      shouldRetryOnError: false,
    }
  );
};
